/* eslint-disable import/no-anonymous-default-export */
import actions from "./action";

const initState = {
  loading: false,
  skillsList: [],
};

export default (state = initState, action) => {
  switch (action.type) {
    case actions.GET_SKILLS: {
      return {
        ...state,
        skillsList: [],
        loading: true,
      };
    }

    case actions.GET_SKILLS_SUCCESS: {
      return {
        ...state,
        skillsList: action.payload,
        loading: false,
      };
    }

    case actions.GET_SKILLS_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    default:
      return state;
  }
};
